(() => {
  const root = window.Shopify?.routes?.root || '/';
  const body = document.body;
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('#main-menu');
  const toast = document.querySelector('[data-cart-toast]');

  const setMenu = (open) => {
    body.classList.toggle('menu-open', open);
    menuButton?.setAttribute('aria-expanded', String(open));
    menuButton?.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
    if (menuButton) menuButton.textContent = open ? 'SLUIT' : 'MENU';
  };

  menuButton?.addEventListener('click', () => setMenu(!body.classList.contains('menu-open')));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-quick-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const original = button?.textContent;
    if (button) {
      button.disabled = true;
      button.textContent = 'Even toevoegen…';
    }
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Product kon niet worden toegevoegd');
      const cart = await fetch(`${root}cart.js`).then((result) => result.json());
      document.querySelectorAll('[data-cart-count]').forEach((counter) => {
        counter.textContent = cart.item_count;
      });
      showToast('Toegevoegd aan je winkelwagen');
    } catch (error) {
      showToast(error.message || 'Er ging iets mis. Probeer het opnieuw.');
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = original;
      }
    }
  });

  const reviewCards = [...document.querySelectorAll('.helti-review-card')];
  let reviewIndex = Math.max(0, reviewCards.findIndex((card) => card.classList.contains('is-active')));
  const showReview = (index) => {
    if (!reviewCards.length) return;
    reviewIndex = (index + reviewCards.length) % reviewCards.length;
    reviewCards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === reviewIndex));
  };
  document.querySelector('[data-review-prev]')?.addEventListener('click', () => showReview(reviewIndex - 1));
  document.querySelector('[data-review-next]')?.addEventListener('click', () => showReview(reviewIndex + 1));

  document.querySelectorAll('[data-variant-selector]').forEach((selector) => {
    const form = selector.closest('[data-product-form]');
    const section = selector.closest('.helti-product-main');
    const price = section?.querySelector('[data-product-price]');
    const stock = section?.querySelector('[data-product-stock]');
    const submit = form?.querySelector('[data-product-submit]');
    const buttons = [...selector.querySelectorAll('[data-variant-id]')];

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const available = button.getAttribute('data-variant-available') === 'true';
        const variantInput = button.querySelector('[data-product-variant-input]');
        if (variantInput) variantInput.checked = true;
        if (price) price.textContent = button.getAttribute('data-variant-price') || price.textContent;
        if (stock) {
          const dot = stock.querySelector('span');
          stock.textContent = available
            ? section?.getAttribute('data-in-stock-text') || 'Op voorraad'
            : section?.getAttribute('data-sold-out-text') || 'Uitverkocht';
          if (dot) stock.prepend(dot);
        }
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available
            ? section?.getAttribute('data-add-label') || 'Toevoegen aan winkelwagen'
            : section?.getAttribute('data-sold-out-label') || 'Uitverkocht';
        }
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      });
    });
  });

  document.querySelectorAll('[data-cart-quantity]').forEach((control) => {
    const input = control.querySelector('[data-cart-quantity-input]');
    const minus = control.querySelector('[data-cart-quantity-minus]');
    const plus = control.querySelector('[data-cart-quantity-plus]');
    const form = control.closest('form');
    let submitTimer = 0;

    const currentQuantity = () => {
      const value = parseInt(input?.value || '0', 10);
      return Number.isFinite(value) ? value : 0;
    };

    const submitCart = () => {
      window.clearTimeout(submitTimer);
      submitTimer = window.setTimeout(() => {
        if (form?.requestSubmit) {
          form.requestSubmit();
        } else {
          form?.submit();
        }
      }, 350);
    };

    const setQuantity = (nextValue) => {
      if (!input) return;
      const next = Math.max(0, nextValue);
      input.value = String(next);
      minus?.toggleAttribute('disabled', next <= 0);
      submitCart();
    };

    minus?.toggleAttribute('disabled', currentQuantity() <= 0);
    minus?.addEventListener('click', () => setQuantity(currentQuantity() - 1));
    plus?.addEventListener('click', () => setQuantity(currentQuantity() + 1));
  });

  const allergenMotion = document.querySelector('[data-allergen-motion]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let motionFrame = 0;

  const updateAllergenMotion = () => {
    motionFrame = 0;
    if (!allergenMotion || reduceMotion.matches || window.innerWidth <= 800) return;

    const rect = allergenMotion.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const rawProgress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
    const progress = Math.max(0, Math.min(1, rawProgress));
    const eased = 1 - Math.pow(1 - progress, 3);
    const drift = (progress - 0.5) * 22;

    allergenMotion.style.setProperty('--helti-left-x', `${(-120 * (1 - eased)) + drift}px`);
    allergenMotion.style.setProperty('--helti-right-x', `${(120 * (1 - eased)) - drift}px`);
    allergenMotion.style.setProperty('--helti-left-y', `${18 * (1 - eased)}px`);
    allergenMotion.style.setProperty('--helti-right-y', `${18 * (1 - eased)}px`);
    allergenMotion.style.setProperty('--helti-left-r', `${-7 + (eased * 8)}deg`);
    allergenMotion.style.setProperty('--helti-right-r', `${7 - (eased * 8)}deg`);
    allergenMotion.style.setProperty('--helti-brownie-y', `${42 - (progress * 72)}px`);
    allergenMotion.style.setProperty('--helti-brownie-scale', String(0.97 + (eased * 0.03)));
  };

  const requestAllergenMotion = () => {
    if (!motionFrame) motionFrame = window.requestAnimationFrame(updateAllergenMotion);
  };

  if (allergenMotion) {
    updateAllergenMotion();
    window.addEventListener('scroll', requestAllergenMotion, { passive: true });
    window.addEventListener('resize', requestAllergenMotion, { passive: true });
    reduceMotion.addEventListener?.('change', requestAllergenMotion);
  }
})();
